import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UserSchema, UserService, AuthService } from 'src/app/core';
import { FilesService } from 'src/app/feature';
import { Subscription } from 'rxjs';

@Component({
  selector: 'user-sidenav',
  templateUrl: './user-sidenav.component.html',
  styleUrls: ['./user-sidenav.component.scss'],
})
export class UserSidenavComponent implements OnInit {
  @Input('isUserActivated') isUserActivated!: boolean;
  @Input('userData') userData!: UserSchema;

  @ViewChild('userProfileImage') userProfileImageDiv!: any;

  panelOpenState: boolean = true;

  _listIconSize: number = 25;
  _sharedFilesCount: number = 0;

  private _subscriptions: Subscription[] = [];
  private set subscriptions(subscription: Subscription | undefined) {
    if (subscription) {
      this._subscriptions.push(subscription);
    }
  }

  constructor(
    private userService: UserService,
    private filesService: FilesService,
    private authService: AuthService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.subscriptions = this.userService.status$.subscribe((statusObj) => {
      if (statusObj.payload && statusObj.status === 'update') {
        this.userData = statusObj.payload;
      }
    });

    this.subscriptions = this.filesService
      .getUserSharedFiles()
      .subscribe((data) => {
        if (data) {
          this._sharedFilesCount = data.length;
        }
      });

    // this.userService
    //   .getUser()
    //   .then((user) => {
    //     this.userData = user;
    //   })
    //   .catch((e) => {});

    this.authService.userProfile.subscribe((profile) => {
      this.userData = profile;
    });
  }

  ngOnDestroy() {
    this._subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
